import { Typography } from 'antd'
import type { ReactNode } from 'react'

const { Title, Text } = Typography

type Props = {
  title: string
  description?: ReactNode
  /** 首页用 2，内页默认 4 */
  level?: 2 | 4
  className?: string
}

export function PageHeader({ title, description, level = 4, className }: Props) {
  return (
    <header className={className ? `page-header ${className}` : 'page-header'}>
      <Title level={level} style={{ marginTop: 0 }}>
        {title}
      </Title>
      {description != null && (
        <Text type="secondary" className="page-header-desc">
          {description}
        </Text>
      )}
    </header>
  )
}
